"use strict";
/**
 * @module Services.Timeseries
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var RangeQueryParametersSerialiser = require("./range-query-parameters-serialiser");
var range_query_request_1 = require("./range-query-request");
/**
 * Serialiser for {@link RangeQueryRequest}
 */
var RangeQueryRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(RangeQueryRequestSerialiserClass, _super);
    function RangeQueryRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link RangeQueryRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link RangeQueryRequest} that was read
     */
    RangeQueryRequestSerialiserClass.prototype.read = function (bis) {
        var topicPath = Codec.readString(bis);
        var parameters = RangeQueryParametersSerialiser.read(bis);
        return new range_query_request_1.RangeQueryRequest(topicPath, parameters);
    };
    /**
     * Write a {@link RangeQueryRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link RangeQueryRequest} to be written
     */
    RangeQueryRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.topicPath);
        RangeQueryParametersSerialiser.write(bos, value.parameters);
    };
    return RangeQueryRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.RangeQueryRequestSerialiserClass = RangeQueryRequestSerialiserClass;
/**
 * The {@link RangeQueryRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.RangeQueryRequestSerialiser = new RangeQueryRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/range-query-request-serialiser.js
// module id = 1320
// module chunks = 1